// extracted by mini-css-extract-plugin
export default {"notification":"_3n4MG","notification-wrapper":"_2Zgef","notificationWrapper":"_2Zgef","tooltip":"_3CYkQ","new-tooltip":"wKGnY","newTooltip":"wKGnY"};